export const ChannelOptions = [
  { label: 'WhatsApp', value: 'WHATSAPP' },
  { label: 'Voz', value: 'VOZ' },
  { label: 'Boot', value: 'BOOT' },
  { label: 'Midias Sociais', value: 'MIDIAS_SOCIAIS' },
  { label: 'Área de Atendimento KPlace', value: 'AREA_ATENDIMENTO_KPLACE' },
];

export default ChannelOptions;
